import React from 'react'
import { Link } from 'react-router-dom'
import { IoIosArrowBack , IoMdMail} from 'react-icons/io'
import { MdCall, MdLocationOn } from 'react-icons/md'

const Termscondition = () => {
  return (
    <div className="min-h-[100vh] md:container md:mx-auto flex-auto">
      <div className='flex justify-start'>
        <div className='flex rounded-md mt-[3vh] p-2 flex-wrap'>
          <Link to={"/menu"}>
            <span className='h-7 w-7 rounded-full border-light-secondary border-2 bg-gray-100 flex items-center justify-center font-bold cursor-pointer hover:bg-light-secondary text-light-secondary hover:text-white' >
              <IoIosArrowBack className='font-bold' size={20} />
            </span>
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
        </div>
      </div>
      <div class="flex">
        <div class="bg-white p-4 m-4 w-1/3">
          <h1 className='flex items-center text-xl'>
            <MdCall size={20} color='red' className='mr-2' />
            <b>Head Office</b>
          </h1>
          <p>0213-5877976</p>
          <h5 className='flex items-center'>
            <MdLocationOn size={20} color='red' className='mr-2' />
            <strong>Location</strong>
          </h5>
          <p>Ocean Tower, 20th Floor, G-3, Block -9, Scheme 5, Main Clifton Road, Karachi, Pakistan</p>
        </div>
        <div class="bg-white p-4 m-4 w-1/3">
          <h1 className='flex items-center text-xl'> <MdCall size={20} color='red' className='mr-2' />
            <b>Regional Office Lahore</b>
          </h1>
          <p>042-35884570</p>
          <h5 className='flex items-center'>
            <MdLocationOn size={20} color='red' className='mr-2' />
            <strong>Location</strong>
          </h5>
          <p>27-A Ali Block New Garden Town Opposite Barkat Market Lahore</p>
        </div>
        <div class="bg-white p-4 m-4 w-1/3">
          <h1 className='flex items-center text-xl'><MdCall size={20} color='red' className='mr-2' />
            <b>Regional Office Islamabad</b>
          </h1>
          <p>0512726877</p>
          <h5 className='flex items-center'>
            <MdLocationOn size={20} color='red' className='mr-2' />
            <strong>Location</strong>
          </h5>
          <p>United Bakery Building, 11، School Rd, F-6 Markaz F-6, Islamabad, Islamabad Capital Territory 44000</p>
        </div>
      </div>
      <div className='flex'>
        <div className='bg-white p-4 m-4 w-[50%]'>
        <h1 className='flex items-center text-xl'> <MdCall size={20} color='red' className='mr-2' />
            <b>Helpline</b>
          </h1>
          <h5>UAN: 111 532 532</h5>
        </div>
        <div className='bg-white p-4 m-4 w-[50%]'>
        <h1 className='flex items-center text-xl'> <IoMdMail size={20} color='red' className='mr-2' />
            <b>Complaints Email</b>
          </h1>
          <h5>customercare@kfcpakistan.com</h5>
        </div>
      </div>
    </div>

  )
}

export default Termscondition